<div class="sivu">
  <details class="ohje-details">
    <summary class="ohje-summary">Mitä tuotantotilasto mittaa?</summary>
    <div class="ohje-sisalto">
      <p class="ohje-kappale">
        Jokainen Lemonaidin AI-poiminta (mobiili ja web) tallettaa mallin ehdotuksen. Kun käyttäjä tallentaa tositteen, ehdotusta verrataan tositteen lopullisiin arvoihin: päivämäärä tarkasti, summa sentin tarkkuudella etumerkki mukaan lukien, valuutta (puuttuva = EUR) ja toimittajarekisterin avain. Myöhemmät muokkaukset päivittävät vertailun, joten alkuperäisen arvon takaisinsyöttö lasketaan
        osumaksi.
      </p>
      <p class="ohje-kappale">Osumaprosentti lasketaan riveistä, joissa tosite on tallennettu ja malli antoi kentälle arvon. "Ei luettu" kertoo, kuinka usein malli jätti kentän tyhjäksi vaikka käyttäjä sen täytti. Käyttäjä ei aina huomaa mallin virhettä, joten luku on yläraja — epäilyttävät rivit kannattaa lisätä testisettiin ihmisverifioitavaksi.</p>
    </div>
  </details>

  <div class="kontrollirivi">
    <mat-form-field class="kapea-kentta">
      <mat-label>Alkaen</mat-label>
      <input matInput type="date" [formField]="lomake.alkaen" />
    </mat-form-field>
    <mat-form-field class="kapea-kentta">
      <mat-label>Asti</mat-label>
      <input matInput type="date" [formField]="lomake.asti" />
    </mat-form-field>
    <mat-form-field class="kapea-kentta">
      <mat-label>Osumattomat kentästä</mat-label>
      <mat-select [formField]="lomake.suodatusKentta">
        <mat-option [value]="kaikkiKentat">Mikä tahansa kenttä</mat-option>
        @for (kentta of kentat; track kentta) {
          <mat-option [value]="kentta">{{ kenttaOtsikot[kentta] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="raja-kentta">
      <mat-label>Rivejä</mat-label>
      <input matInput type="number" [formField]="lomake.raja" />
    </mat-form-field>
    <app-primary-button (click)="hae()" [disabled]="lataa()" class="aloita-nappi" actionId="Hae tositteen luvun tuotantotilasto">Hae</app-primary-button>
  </div>

  @if (lataa()) {
    <mat-spinner diameter="32"></mat-spinner>
  } @else {
    <h3 class="osio-otsikko">Yhteenveto</h3>
    @if (!yhteenveto().length) {
      <p class="tyhja-viesti">Ei poimintoja valitulla aikavälillä.</p>
    } @else {
      <div class="taulukko-kehys">
        <table class="tilasto-taulukko">
          <thead>
            <tr>
              <th>Kuukausi</th>
              <th>Malli</th>
              <th>Prompt</th>
              <th>Kanava</th>
              <th class="numero">Poimintoja</th>
              <th class="numero">Virheitä</th>
              <th class="numero">Tallennettuja</th>
              @for (kentta of kentat; track kentta) {
                <th class="numero">{{ kenttaOtsikot[kentta] }}</th>
              }
              <th class="numero">Tokenit in / out</th>
            </tr>
          </thead>
          <tbody>
            @for (rivi of yhteenveto(); track rivi.kuukausi + rivi.malli + rivi.promptTunniste + rivi.tallennusKanava) {
              <tr>
                <td>{{ rivi.kuukausi | date: 'MM/yyyy' }}</td>
                <td>{{ rivi.malli ?? '—' }}</td>
                <td class="mono">{{ rivi.promptTunniste ?? '—' }}</td>
                <td>{{ rivi.tallennusKanava ?? 'ei tallennettu' }}</td>
                <td class="numero">{{ rivi.poimintoja }}</td>
                <td class="numero">{{ rivi.virheita }} ({{ virheprosentti(rivi) | number: '1.0-0' }}%)</td>
                <td class="numero">{{ rivi.tallennettuja }} ({{ tallennusprosentti(rivi) | number: '1.0-0' }}%)</td>
                @for (kentta of kentat; track kentta) {
                  <td class="numero" [matTooltip]="rivi.kentat[kentta].osumia + ' / ' + rivi.kentat[kentta].arvioituja + ' arvioitua, ei luettu ' + rivi.kentat[kentta].eiLuettu">
                    @if (prosentti(rivi.kentat[kentta]) !== null) {
                      <strong>{{ prosentti(rivi.kentat[kentta]) | number: '1.1-1' }}%</strong>
                    } @else {
                      <span class="ei-tuloksia">—</span>
                    }
                  </td>
                }
                <td class="numero">{{ rivi.inputTokenit | number }} / {{ rivi.outputTokenit | number }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <h3 class="osio-otsikko">Osumattomat</h3>
    @if (!osumattomat().length) {
      <p class="tyhja-viesti">Ei osumattomia rivejä valitulla aikavälillä.</p>
    } @else {
      <div class="taulukko-kehys">
        <table class="tilasto-taulukko">
          <thead>
            <tr>
              <th>Tallennettu</th>
              <th>Asiakas</th>
              <th>Malli</th>
              @for (kentta of kentat; track kentta) {
                <th>{{ kenttaOtsikot[kentta] }}<br /><span class="alaotsikko">ehdotus → tallennettu</span></th>
              }
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (rivi of osumattomat(); track rivi.poimintaAvain) {
              <tr>
                <td>
                  {{ rivi.tallennettu | date: 'dd.MM.yyyy HH:mm' }}<br /><span class="alaotsikko">{{ rivi.tallennusKanava }}</span>
                </td>
                <td>{{ rivi.asiakasNimi ?? rivi.asiakasAvain }}</td>
                <td>
                  {{ rivi.malli ?? '—' }}<br /><span class="alaotsikko mono">{{ rivi.promptTunniste }}</span>
                </td>
                <td [class.osumaton]="rivi.osumat.paivamaara === false">{{ rivi.ehdotettuPaivamaara ?? '—' }} → {{ rivi.tallennettuPaivamaara ?? '—' }}</td>
                <td [class.osumaton]="rivi.osumat.summa === false">{{ rivi.ehdotettuSumma ?? '—' }} → {{ rivi.tallennettuSumma ?? '—' }}</td>
                <td [class.osumaton]="rivi.osumat.valuutta === false">{{ rivi.ehdotettuValuutta ?? 'EUR' }} → {{ rivi.tallennettuValuutta ?? 'EUR' }}</td>
                <td [class.osumaton]="rivi.osumat.toimittajaAvain === false">
                  {{ rivi.ehdotettuToimittaja ?? '—' }} → {{ rivi.tallennettuToimittaja ?? '—' }}<br />
                  <span class="alaotsikko mono">{{ rivi.ehdotettuToimittajaAvain ?? 'null' }} → {{ rivi.tallennettuToimittajaAvain ?? 'null' }}</span>
                </td>
                <td class="toiminnot">
                  <app-secondary-button (click)="vaihdaPerustelu(rivi)" actionId="Näytä AI-poiminnan perustelu">{{ avattuPoimintaAvain() === rivi.poimintaAvain ? 'Piilota' : 'Perustelu' }}</app-secondary-button>
                  @if (voiLisataTestisettiin(rivi)) {
                    <app-secondary-button (click)="lisaaTestisettiin(rivi)" actionId="Lisää tuotantotosite testisettiin">Lisää testisettiin</app-secondary-button>
                  }
                </td>
              </tr>
              @if (avattuPoimintaAvain() === rivi.poimintaAvain) {
                <tr>
                  <td colspan="8" class="perustelu-solu">
                    @if (perusteluaLadataan() && !perustelut().has(rivi.poimintaAvain)) {
                      <mat-spinner diameter="18"></mat-spinner>
                    } @else if (perustelut().get(rivi.poimintaAvain); as perustelu) {
                      <div class="perustelu-otsikko">Perustelu</div>
                      <pre class="perustelu-teksti">{{ perustelu.reasoning ?? '—' }}</pre>
                      <div class="perustelu-otsikko">Raakavastaus</div>
                      <pre class="perustelu-teksti">{{ perustelu.raakaVastaus ?? '—' }}</pre>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>
